import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  function update(k, v) {
    setForm((f) => ({ ...f, [k]: v }));
  }

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await register(form);
      toast.success("Cuenta creada");
      navigate("/dashboard");
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-8 sm:p-12 order-2 lg:order-1">
        <Card className="w-full max-w-md border-slate-200">
          <CardContent className="p-8">
            <Link to="/" className="overline" data-testid="register-back-home">← Volver</Link>
            <h1 className="font-display text-3xl font-light mt-4">Crear cuenta</h1>
            <p className="text-slate-600 mt-2 text-sm">Empieza a agendar y consulta tu historial.</p>
            <form className="mt-8 space-y-4" onSubmit={onSubmit}>
              <div className="space-y-2">
                <Label htmlFor="name">Nombre</Label>
                <Input id="name" required value={form.name} onChange={(e) => update("name", e.target.value)} data-testid="register-name-input" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="email">Correo</Label>
                <Input id="email" type="email" required value={form.email} onChange={(e) => update("email", e.target.value)} data-testid="register-email-input" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="phone">Teléfono (opcional)</Label>
                <Input id="phone" value={form.phone} onChange={(e) => update("phone", e.target.value)} data-testid="register-phone-input" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Contraseña</Label>
                <Input id="password" type="password" required minLength={6} value={form.password} onChange={(e) => update("password", e.target.value)} data-testid="register-password-input" />
              </div>
              {err && <p className="text-sm text-red-700" data-testid="register-error">{err}</p>}
              <Button type="submit" className="w-full" disabled={loading} data-testid="register-submit-btn">
                {loading ? "Creando…" : "Crear cuenta"}
              </Button>
            </form>
            <p className="text-sm text-slate-600 mt-6">
              ¿Ya tienes cuenta?{" "}
              <Link to="/login" className="text-primary underline" data-testid="register-go-login">Iniciar sesión</Link>
            </p>
          </CardContent>
        </Card>
      </div>
      <div className="hidden lg:block relative overflow-hidden order-1 lg:order-2">
        <img src="https://images.unsplash.com/photo-1762631203805-88841687ab4d" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-slate-900/30" />
      </div>
    </div>
  );
}
